import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  getCategoryData: {
    loading: false,
    error: null,
    data: null,
  },
  addCategoryData: {
    loading: false,
    error: null,
    data: null,
  },
  deleteCategory: {
    loading: false,
    error: null,
    data: null,
  },
  editCategory: {
    loading: false,
    error: null,
    data: null,
  },
  selectedCategory: {
    loading: false,
    error: null,
    data: null,
  },
};

const CategorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    getCategoryDataStart: (state) => {
      state.getCategoryData.loading = true;
      state.getCategoryData.error = null;
      state.getCategoryData.data = null;
    },
    getCategoryDataSuccess: (state, action) => {
      state.getCategoryData.loading = false;
      state.getCategoryData.data = action.payload;
      state.getCategoryData.error = null;
    },
    getCategoryDataFailure: (state, action) => {
      state.getCategoryData.loading = false;
      state.getCategoryData.error = action.payload;
      state.getCategoryData.data = null;
    },

    addCategoryStart: (state) => {
      state.addCategoryData.loading = true;
      state.addCategoryData.error = null;
      state.addCategoryData.data = null;
    },
    addCategorySuccess: (state, action) => {
      state.addCategoryData.loading = false;
      state.addCategoryData.data = action.payload;
      state.addCategoryData.error = null;
    },
    addCategoryFailure: (state, action) => {
      state.addCategoryData.loading = false;
      state.addCategoryData.error = action.payload;
      state.addCategoryData.data = null;
    },
    addCategoryResetForm: (state, action) => {
      state.addCategoryData.loading = false;
      state.addCategoryData.error = null;
      state.addCategoryData.data = null;
    },

    deleteCategoryStart: (state) => {
      state.deleteCategory.loading = true;
      state.deleteCategory.error = null;
      state.deleteCategory.data = null;
    },
    deleteCategorySuccess: (state, action) => {
      state.deleteCategory.loading = false;
      state.deleteCategory.data = action.payload;
      state.deleteCategory.error = null;
    },
    deleteCategoryFailure: (state, action) => {
      state.deleteCategory.loading = false;
      state.deleteCategory.error = action.payload;
      state.deleteCategory.data = null;
    },
    deleteCategoryResetForm: (state, action) => {
      state.deleteCategory.loading = false;
      state.deleteCategory.error = null;
      state.deleteCategory.data = null;
    },

    editCategoryStart: (state) => {
      state.editCategory.loading = true;
      state.editCategory.error = null;
      state.editCategory.data = null;
    },
    editCategorySuccess: (state, action) => {
      state.editCategory.loading = false;
      state.editCategory.data = action.payload;
      state.editCategory.error = null;
    },
    editCategoryFailure: (state, action) => {
      state.editCategory.loading = false;
      state.editCategory.error = action.payload;
      state.editCategory.data = null;
    },
    editCategoryResetForm: (state, action) => {
      state.editCategory.loading = false;
      state.editCategory.error = null;
      state.editCategory.data = null;
    },

    selectedCategoryStart: (state) => {
      state.selectedCategory.loading = true;
      state.selectedCategory.error = null;
      state.selectedCategory.data = null;
    },
    selectedCategorySuccess: (state, action) => {
      state.selectedCategory.loading = false;
      state.selectedCategory.data = action.payload;
      state.selectedCategory.error = null;
    },
    selectedCategoryFailure: (state, action) => {
      state.selectedCategory.loading = false;
      state.selectedCategory.error = action.payload;
      state.selectedCategory.data = null;
    },
    selectedCategoryResetForm: (state, action) => {
      state.selectedCategory.loading = false;
      state.selectedCategory.error = null;
      state.selectedCategory.data = null;
    },
    
  },
});

export const {
  getCategoryDataStart,
  getCategoryDataFailure,
  getCategoryDataSuccess,

  addCategoryStart,
  addCategorySuccess,
  addCategoryFailure,
  editCategoryStart,
  editCategorySuccess,
  editCategoryFailure,
  editCategoryResetForm,

  deleteCategoryStart,
  deleteCategorySuccess,
  deleteCategoryFailure,
  deleteCategoryResetForm,
  addCategoryResetForm,

  selectedCategoryStart,
  selectedCategorySuccess,
  selectedCategoryFailure,
  selectedCategoryResetForm,

} = CategorySlice.actions;

export default CategorySlice.reducer;
